<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		class="styretavla-logo"
		data-name="Styretavla"
		viewBox="0 0 224.78 74.72"
		:style="svgStyle"
		@mouseover="hover"
		@mouseout="out"
		>
		<defs>
			<clipPath id="clip-path" transform="translate(-1.15 -7.17)">
				<path fill="none" d="M110.66 28.75l-9.6-7.71L102.8 0l127.95 4.91v83.03l-129.69-4.49V60.66l11.13 6.31 104.31 1.05-1.74-50.14-98.4 1.05-5.7 9.82z" />
			</clipPath>
		</defs>
		<path :style="secondaryFillStyle" transform="translate(-1.15 -7.17)" d="M14.9 42.12a5 5 0 0 0-4.32-2.25 4.56 4.56 0 0 0-2.16.55 1.87 1.87 0 0 0-1.06 1.79 1.56 1.56 0 0 0 .87 1.48 10.41 10.41 0 0 0 2.21.78c.89.21 1.85.44 2.88.66a12 12 0 0 1 2.87 1.06 6.31 6.31 0 0 1 2.21 2 5.84 5.84 0 0 1 .87 3.4 6.16 6.16 0 0 1-.85 3.34 6.58 6.58 0 0 1-2.21 2.18 9.92 9.92 0 0 1-3.05 1.2 16.48 16.48 0 0 1-3.41.37A14.68 14.68 0 0 1 5 57.9a9 9 0 0 1-3.86-2.67l3.68-3.45a10.38 10.38 0 0 0 2.28 2 5.54 5.54 0 0 0 3 .76 6.14 6.14 0 0 0 1.25-.14 4.09 4.09 0 0 0 1.19-.46 2.82 2.82 0 0 0 .9-.81 1.86 1.86 0 0 0 .31-1.13 1.89 1.89 0 0 0-.87-1.71 8 8 0 0 0-2.21-.89c-.89-.23-1.85-.45-2.87-.65a11.34 11.34 0 0 1-2.88-1 6.15 6.15 0 0 1-2.21-1.87 5.52 5.52 0 0 1-.87-3.31 6.45 6.45 0 0 1 .76-3.2 6.8 6.8 0 0 1 2-2.23 8.6 8.6 0 0 1 2.85-1.28 12.92 12.92 0 0 1 3.27-.42 13.27 13.27 0 0 1 4.37.76 7.14 7.14 0 0 1 3.49 2.6zM21.25 40.7V36h4.56v-6.39h5.52V36h6.07v4.7h-6.07v9.66A4.77 4.77 0 0 0 32 53a2.71 2.71 0 0 0 2.46 1 8.76 8.76 0 0 0 1.54-.22 3.24 3.24 0 0 0 1.38-.53v4.65a6.88 6.88 0 0 1-2.14.57 17.71 17.71 0 0 1-2.23.17 11.31 11.31 0 0 1-3.61-.49 4.69 4.69 0 0 1-2.21-1.47 5.57 5.57 0 0 1-1.11-2.46 17.24 17.24 0 0 1-.29-3.4V40.7zM39 36h6.07l6.16 15.32h.09L56.86 36h5.75L52.16 62.82a16.67 16.67 0 0 1-1.31 2.74 7.74 7.74 0 0 1-1.68 2 6.39 6.39 0 0 1-2.27 1.19 11.2 11.2 0 0 1-3.15.39 16.28 16.28 0 0 1-4.24-.55l.69-5a10.8 10.8 0 0 0 1.36.4 7.08 7.08 0 0 0 1.45.16 6.82 6.82 0 0 0 1.7-.19 2.94 2.94 0 0 0 2-1.59c.21-.41.44-.91.69-1.49l1.06-2.62zM66.15 36h5.52v3.5h.09a7 7 0 0 1 2.62-3 7.21 7.21 0 0 1 3.91-1.06 5.36 5.36 0 0 1 1 .09c.32.07.65.14 1 .23v5.34c-.46-.12-.91-.22-1.36-.3a7.32 7.32 0 0 0-1.31-.11 5.86 5.86 0 0 0-3.1.71 5.45 5.45 0 0 0-2.63 3.47 7.59 7.59 0 0 0-.2 1.38v11.83h-5.54zM88.73 49a5.65 5.65 0 0 0 1.93 3.86 6.07 6.07 0 0 0 4 1.38 6.56 6.56 0 0 0 3.47-.85 9.83 9.83 0 0 0 2.46-2.14l4 3a11.19 11.19 0 0 1-4.33 3.4 12.61 12.61 0 0 1-5 1 13.26 13.26 0 0 1-4.69-.83 11.16 11.16 0 0 1-3.82-2.35 10.85 10.85 0 0 1-2.55-3.66 12.4 12.4 0 0 1 0-9.52 11 11 0 0 1 6.37-6 13.26 13.26 0 0 1 4.69-.83 10.71 10.71 0 0 1 4.21.81 8.93 8.93 0 0 1 3.26 2.32 10.68 10.68 0 0 1 2.12 3.75 15.82 15.82 0 0 1 .76 5.13V49zm11.32-4.14A5.18 5.18 0 0 0 98.53 41a5.68 5.68 0 0 0-4.09-1.41A5.39 5.39 0 0 0 90.5 41a6.42 6.42 0 0 0-1.77 3.82z" />
		<path :style="primaryFillStyle" transform="translate(-1.15 -7.17)" d="M108.42 40.7V36H113v-6.39h5.52V36h6.08v4.7h-6.08v9.66a4.77 4.77 0 0 0 .63 2.62 2.71 2.71 0 0 0 2.46 1 8.76 8.76 0 0 0 1.61-.16 3.24 3.24 0 0 0 1.38-.53v4.61a6.88 6.88 0 0 1-2.14.57 17.71 17.71 0 0 1-2.23.17 11.42 11.42 0 0 1-3.62-.49 4.71 4.71 0 0 1-2.2-1.47 5.57 5.57 0 0 1-1.11-2.46 17.19 17.19 0 0 1-.3-3.4V40.7zM143 55.05h-.14a7.12 7.12 0 0 1-3 2.74 9.63 9.63 0 0 1-4 .85 10.53 10.53 0 0 1-3-.42A7.92 7.92 0 0 1 130.2 57a6.36 6.36 0 0 1-1.82-2.07 5.87 5.87 0 0 1-.69-2.9 6.71 6.71 0 0 1 .65-3.06 6.32 6.32 0 0 1 1.72-2.11 8.77 8.77 0 0 1 2.51-1.36 17 17 0 0 1 3-.76 26.69 26.69 0 0 1 3.1-.32c1 0 2-.07 3-.07H143v-.6a3.58 3.58 0 0 0-1.43-3.1 6 6 0 0 0-3.63-1 8.61 8.61 0 0 0-3.27.62 8.42 8.42 0 0 0-2.67 1.62l-2.9-2.9a10.77 10.77 0 0 1 4.3-2.71 15.91 15.91 0 0 1 5.08-.83 12.86 12.86 0 0 1 4 .53 8.8 8.8 0 0 1 2.67 1.36 6 6 0 0 1 1.63 1.91 8.71 8.71 0 0 1 .83 2.18 11.84 11.84 0 0 1 .3 2.14v14.51h-5zm-.32-6.86h-1.16c-.76 0-1.62 0-2.57.1a13.38 13.38 0 0 0-2.69.43 6 6 0 0 0-2.14 1 2.18 2.18 0 0 0-.88 1.86 2.35 2.35 0 0 0 .35 1.31 3.21 3.21 0 0 0 .9.9 3.84 3.84 0 0 0 1.24.53 6.49 6.49 0 0 0 1.38.16 5.77 5.77 0 0 0 4.21-1.36 5 5 0 0 0 1.36-3.7zM151.15 36h6l5.89 15.46h.09L169.09 36h5.66l-8.69 22.08h-5.89zM178.39 23.31h5.51v34.77h-5.51zM204.33 55.05h-.14a7.12 7.12 0 0 1-3 2.74 9.58 9.58 0 0 1-4 .85 10.6 10.6 0 0 1-3-.42 7.92 7.92 0 0 1-2.63-1.22 6.34 6.34 0 0 1-1.81-2.07 5.87 5.87 0 0 1-.69-2.9 6.71 6.71 0 0 1 .64-3.03 6.23 6.23 0 0 1 1.73-2.11 8.71 8.71 0 0 1 2.5-1.36 17 17 0 0 1 3-.76 26.91 26.91 0 0 1 3.1-.32c1.05 0 2-.07 2.95-.07h1.38v-.6a3.58 3.58 0 0 0-1.43-3.1 6 6 0 0 0-3.63-1 8.46 8.46 0 0 0-5.89 2.3l-2.9-2.9a10.77 10.77 0 0 1 4.3-2.71 15.92 15.92 0 0 1 5.09-.83 12.84 12.84 0 0 1 3.95.53 8.68 8.68 0 0 1 2.67 1.36 5.88 5.88 0 0 1 1.63 1.91 8.71 8.71 0 0 1 .83 2.18 11.84 11.84 0 0 1 .3 2.14c0 .69.05 1.3.05 1.82v12.6h-5zm-.33-6.86h-1.15c-.77 0-1.63 0-2.58.1a13.38 13.38 0 0 0-2.69.43 6 6 0 0 0-2.14 1 2.2 2.2 0 0 0-.87 1.86 2.34 2.34 0 0 0 .34 1.31 3.21 3.21 0 0 0 .9.9 3.94 3.94 0 0 0 1.24.53 6.49 6.49 0 0 0 1.38.16 5.77 5.77 0 0 0 4.21-1.36 5 5 0 0 0 1.36-3.7z" />
		<g clip-path="url(#clip-path)">
			<path :style="secondaryStrokeStyle" stroke-miterlimit="10" stroke-width="6" d="M106.07 24.03V9.53A6.31 6.31 0 0 1 112.13 3h103.59a6.31 6.31 0 0 1 6.06 6.53v55.66a6.32 6.32 0 0 1-6.06 6.53H112.13a6.32 6.32 0 0 1-6.06-6.53V53.94" />
		</g>
	</svg>
</template>

<script lang="ts">
	import Vue from "vue";
	import { Component, Prop, Watch } from "vue-property-decorator";

	@Component
	export default class StyretavlaLogo extends Vue {
		@Prop({ default: 120 })
		width!: number;

		@Prop({ default: "#17b25d" })
		primaryColor!: string;

		@Prop({ default: "#ffffff" })
		secondaryColor!: string;

		@Prop({ default: "#ff5252" })
		accentColor!: string;

		colors: { [key: string]: string } = {};
		protected _temp: any = {};

		get svgStyle() {
			return {
				width: `${this.width}px`,
			};
		}

		get primaryFillStyle() {
			return {
				fill: this.colors.primary,
			};
		}

		get secondaryFillStyle() {
			return {
				fill: this.colors.secondary,
			};
		}

		get secondaryStrokeStyle() {
			return {
				fill: "none",
				stroke: this.colors.secondary,
			};
		}

		@Watch("primaryColor", { immediate: true })
		@Watch("secondaryColor")
		@Watch("accentColor")
		updateColor() {
			this.colors = {
				accent: this.accentColor,
				primary: this.primaryColor,
				secondary: this.secondaryColor,
			};
		}

		hover() {
			this._temp = { ...this.colors };

			this.colors.primary = this._temp.secondary;
			this.colors.secondary = this._temp.primary;
		}

		out() {
			this.colors.primary = this._temp.primary;
			this.colors.secondary = this._temp.secondary;

			this._temp = {};
		}
	}
</script>

<style lang="scss" scoped>
	.styretavla-logo {
		display: block;

		path {
			transition: .3s ease-in-out all;
		}
	}
</style>
